var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12722_301116",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9923 2.33027L22.171 5.50905C23.0497 6.38773 23.0497 7.81235 22.171 8.69103L19.5866 11.275C20.6696 11.4374 21.5 12.3717 21.5 13.4999V18.7499C21.5 19.9926 20.4926 20.9999 19.25 20.9999H5.75C4.50736 20.9999 3.5 19.9926 3.5 18.7499V5.24994C3.5 4.0073 4.50736 2.99994 5.75 2.99994H11C12.1289 2.99994 13.0637 3.83139 13.2253 4.91535L15.8103 2.33027C16.689 1.45159 18.1136 1.45159 18.9923 2.33027ZM5 18.7499C5 19.1642 5.33579 19.4999 5.75 19.4999L11.749 19.4993L11.75 12.7499L5 12.7493V18.7499ZM13.249 19.4993L19.25 19.4999C19.6642 19.4999 20 19.1642 20 18.7499V13.4999C20 13.0857 19.6642 12.7499 19.25 12.7499L13.249 12.7493V19.4993ZM11 4.49994H5.75C5.33579 4.49994 5 4.83573 5 5.24994V11.2493H11.75V5.24994C11.75 4.83573 11.4142 4.49994 11 4.49994ZM13.25 9.30926V11.2499L15.19 11.2493L13.25 9.30926ZM16.8709 3.39093L13.6922 6.56971C13.3993 6.8626 13.3993 7.33747 13.6922 7.63037L16.8709 10.8091C17.1638 11.102 17.6387 11.102 17.9316 10.8091L21.1104 7.63037C21.4033 7.33747 21.4033 6.8626 21.1104 6.56971L17.9316 3.39093C17.6387 3.09804 17.1638 3.09804 16.8709 3.39093Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12722_301116)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#616161"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign);
export default __webpack_public_path__ + "static/media/design.7f6e4769e747e096c6758962ad9badff.svg";
export { ForwardRef as ReactComponent };